'use client';
import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { PostItemProps } from '../../posts.props';
import routes from '@routes';
import Link from 'next/link';
import getParseRoute from '@utils/helpers/parse-route';
import ViewIcon from '@icons-components/view-icon';
import PostItemSchema from '@schema/post/post-item';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const PostItemMobile = ({ slug, image = '/images/default.jpg', hits, title, publishedAt }: PostItemProps) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <Link passHref={true} className={'flex w-full justify-center'} href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: slug }, locale: lang })}>
      <Div itemScope itemType="https://schema.org/BlogPosting" className={'w-full h-24 bg-white z-[3] rounded-xl'}>
        <Div className={'object-contain'}>
          <Div className={'relative w-24 h-24'}>
            <Image alt={title} src={image} fill={true} className={'rounded-r-xl object-cover'}/>
          </Div>
        </Div>
        <Div className={'flex-col grow p-3 justify-between overflow-hidden'}>
          <Text className={'overflow-hidden text-ellipsis'} align={'right'} type={'medium'} color={'grey.900'} typography={'sm'}>
            {title}
          </Text>
          <Div className={'items-center justify-end gap-x-1'}>
            <Div className={'w-3 h-2 relative'}>
              <ViewIcon/>
            </Div>
            <Text align={'left'} typography={'xs'}>
              {hits}
            </Text>
          </Div>
        </Div>
        <PostItemSchema
          slug={slug}
          publishedAt={publishedAt}
          image={image}
        />
      </Div>
    </Link>
  );
};

export default PostItemMobile;
